import { render, staticRenderFns } from "./SurveyStepOther.vue?vue&type=template&id=dc1414aa&"
import script from "./SurveyStepOther.vue?vue&type=script&lang=ts&"
export * from "./SurveyStepOther.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports